import { combineReducers } from 'redux';

import { reducer as ip } from './ipModule';
import { reducer as dynamicChild } from './dynamicChildModule';

export default combineReducers({
	dynamicChild,
	ip,
});
